module.exports = __webpack_public_path__ + "fontawesome-webfont.c8ddf1e5e5bf3682bc7b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.woff?v=4.6.3
// module id = 823
// module chunks = 2